require('./expensesByCategoryFilterApplied.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { Component } = require('react');

// @ components
const { LabelFilterRange } = require('commonsComponents/labelFilterRange');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');

// @ commons
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;

// @ constants
const { DATE_PICKER_CUSTOM_DATE_FORMAT } = require('constants/commonsComponents');

class ExpensesByCategoryFilterApplied extends Component {

    buildDateFilterLabel() {
        const { immFilters, removeFilter } = this.props;
        const immFilterDate = immFilters.get('date');

        let labelFromDate = immFilterDate.get('from') ? immFilterDate.get('from').format(formatText(DATE_PICKER_CUSTOM_DATE_FORMAT)) : '';
        let labelToDate = immFilterDate.get('to') ? immFilterDate.get('to').format(formatText(DATE_PICKER_CUSTOM_DATE_FORMAT)) : '';

        if (labelFromDate && !labelToDate) {
            labelFromDate = `${ formatText('datePickerCustom-from') }: ${ labelFromDate }`;
        }

        if (!labelFromDate && labelToDate) {
            labelToDate = `${ formatText('datePickerCustom-to') }: ${ labelToDate }`;
        }

        return (
            <LabelFilterRange
                key="filter-date"
                from={labelFromDate}
                to={labelToDate}
                closeCallback={() => removeFilter('date')}
            />
        );
    }

    render() {
        const { immFilters, totalMovementsCategory, totalExpensesCategory, currency } = this.props;
        const immFilterDate = immFilters.get('date');
        const filterDateLabel = immFilterDate && immFilterDate.get('isActive') ? this.buildDateFilterLabel() : '';

        return (
            <div className="row expenses-by-category-filter-applied">
                <div className="col-xs-6 expenses-by-category-filter-applied__label">
                    {filterDateLabel}
                </div>
                {totalMovementsCategory > 0 && <div className="col-xs-6 expenses-by-category-filter-applied__information">
                    <p className="count-expense"><FormattedText value="categoriesInfo-total"/><span>
                        <OneLineSymbolAmount
                            language={getLanguage()}
                            positiveAmount
                            amountObject={{amount: totalExpensesCategory, currencySymbol: currency}}
                            amountObjectFormatted={{currencySymbol: currency}}
                        />
                    </span></p>
                    <p className="count-movements">{totalMovementsCategory} <FormattedText value="categoriesInfo-movements"/></p>
                </div>}
            </div>
        );
    }
}

ExpensesByCategoryFilterApplied.propTypes = {
    currency: PropTypes.string,
    immFilters: PropTypes.object.isRequired,
    removeFilter: PropTypes.func,
    totalExpensesCategory: PropTypes.number,
    totalMovementsCategory: PropTypes.number,
}

module.exports = ExpensesByCategoryFilterApplied;
